export const onDocumentDragOver = e => {
  e.preventDefault();
};

export const onDocumentDrop = e => {
  e.preventDefault();
};
